import * as React from "react"

function SvgFullheart(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.735 1.797c.713-.349 1.335-.464 2.3-.464 2.47.01 4.298 2.094 4.298 4.747 0 2.025-1.129 3.982-3.232 5.873-1.104.993-2.514 1.976-3.523 2.499L8 14.75l-.578-.3c-1.01-.522-2.419-1.505-3.523-2.498C1.796 10.062.667 8.105.667 6.08c0-2.682 1.81-4.747 4.303-4.747.93 0 1.584.126 2.311.486a4.2 4.2 0 01.712.445c.23-.182.478-.337.742-.467z"
        fill="#fff"
      />
    </svg>
  )
}

export default SvgFullheart

